<script>
import resources from './resources'

export default {
  name: 'scheduling-rollback-from-delayed',
  mixins: [resources]
}
</script>

<template lang="pug">
  .col-xs-12.col-sm-10.col-sm-offset-1
    h4 DESEJA RETORNAR ESTE EVENTO PARA EM ATENDIMENTO?
    .row.border-bottom.dark-grey
      .col-xs-12(style='margin-bottom:15px;color: #2071b9;') Resumo dos eventos selecionados
      .hidden-xs.col-sm-4.grey(style='line-height:100%; margin:10px 0px;')
        small Agenda Profissional
      .hidden-xs.col-sm-4.grey(style='line-height:100%; margin:10px 0px;')
        small Paciente
      .hidden-xs.col-sm-2.grey(style='line-height:100%; margin:10px 0px;')
        small Data
        br
      .hidden-xs.col-sm-2.grey(style='line-height:100%; margin:10px 0px;')
        small Hora
        br
      .clearfix
      template(v-for="schedule in schedules")
        .col-xs-12.col-sm-4(style='line-height:100%;margin-bottom:10px;')
          small.hidden-sm.hidden-md.hidden-lg.grey
            | Agenda Profissional
            br
          small {{ schedule.agenda_name }}
        .col-xs-12.col-sm-4(style='line-height:100%;margin-bottom:10px;')
          small.hidden-sm.hidden-md.hidden-lg.grey
            | Paciente
            br
          small {{ schedule.patient.name }}
        .col-xs-12.col-sm-2
          small.hidden-sm.hidden-md.hidden-lg.grey
            | Data
            br
          small {{ formatDate(schedule.date) }}
        .col-xs-12.col-sm-2
          small.hidden-sm.hidden-md.hidden-lg.grey
            | Hora
            br
          small {{ schedule.time }}
        .clearfix

    .buttons-wrapper
      button.btn.cancel(data-dismiss='modal')
        span.icon 
        |  Não, Voltar
      button.btn.save(@click.prevent="doConfirmedAll")
        template(v-if="schedules.length > 1")
          span.icon 
          |  Sim, Definir como Agendado
        template(v-if="schedules.length <= 1")
          span.icon 
          |  Sim, Confirmar
</template>



// WEBPACK FOOTER //
// src/app/professional/dashboard/company/gadget/components/active-agenda/components/in-attendance/in-attendance.vue